export default __webpack_public_path__ + "static/media/dinner6.51ef2124.png";